<script setup lang="ts">
onMounted(() => {
  // @ts-ignore
  // ;(<any>window).siteKey = config.global.siteKey;
})
</script>

<template>
  <NuxtLayout></NuxtLayout>
</template>
